<template>
  <div style="line-height: 0px;">
    <el-form :inline='true' style="text-align: center;">
      <el-form-item>
        <el-input
          v-model='searchForm.casename'
          placeholder='元素名称'
          clearable
        >
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click='getUiCaseList'>搜索</el-button>
      </el-form-item>

      <el-form-item>
        <el-button type='primary' @click='dialogVisible = true'>新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-popconfirm title='这是确定批量删除吗？' @confirm='delHandle(null)'>
          <el-button type='danger' slot='reference' :disabled='delBtlStatu'>批量删除</el-button>
        </el-popconfirm>
      </el-form-item>

      <el-form-item>
        <el-button type='primary' @click='runAllCase()'>运行全部用例</el-button>
      </el-form-item>

    </el-form>

    <el-table
      ref='multipleTable'
      :data='tableData'
      tooltip-effect='dark'
      style='width: 100%;'
      :height='700'
      border
      stripe
      @selection-change='handleSelectionChange'
      :header-cell-style="{background:'#eef1f6',color:'#606266'}">

      <el-table-column
        type='selection'
        width='55'>
      </el-table-column>

      <!--<el-table-column-->
      <!--prop='id'-->
      <!--label='id'-->
      <!--width='120'>-->
      <!--</el-table-column>-->

      <el-table-column
        prop='casename'
        label='用例名称'
        width='120'>
      </el-table-column>
      <el-table-column
        prop='url'
        label='测试地址'
        show-overflow-tooltip>
      </el-table-column>

      <el-table-column
        prop='description'
        label='用例描述'
        show-overflow-tooltip>
      </el-table-column>

      <el-table-column
        prop='runningTime'
        label='运行时间'
        width='120'>
      </el-table-column>

      <el-table-column
        prop='statu'
        label='状态'
        width='120'>
        <template slot-scope='scope'>
          <el-tag size='small' v-if='scope.row.statu === 1' type='success'>启用</el-tag>
          <el-tag size='small' v-else-if='scope.row.statu === 0' type='danger'>禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop='terminal'
        label='终端'
        width='120'>
      </el-table-column>

      <el-table-column
        prop='deviname'
        label='浏览器'
        width='120'>
      </el-table-column>

      <el-table-column
        prop='vsion'
        label='浏览器版本'
        width='120'>
      </el-table-column>

      <el-table-column
        prop='icon'
        label='操作'
        width='400'>

        <template slot-scope='scope'>

          <el-button type='text' @click='editHandle(scope.row.id)'>编辑</el-button>
          <el-divider direction='vertical'></el-divider>

          <template>
            <el-popconfirm title='这条用例确定删除吗？' @confirm='delHandle(scope.row.id)'>
              <el-button type='text' slot='reference'>删除</el-button>
            </el-popconfirm>
          </template>

          <el-divider direction='vertical'></el-divider>
          <el-button type='text' @click='runAllCaselLocal(scope.row.id)' v-loading.fullscreen.lock='fullscreenLoading'>
            运行用例
          </el-button>

        </template>
      </el-table-column>

    </el-table>

    <el-pagination
      @size-change='handleSizeChange'
      @current-change='handleCurrentChange'
      layout='total, sizes, prev, pager, next, jumper'
      :page-sizes='[10, 20, 50, 100]'
      :current-page='current'
      :page-size='size'
      :total='total'>
    </el-pagination>

    <el-dialog
      title='新增/编辑'
      :visible.sync='dialogVisible'
      width='75%'
      :before-close='handleClose'>
      <el-tabs v-model='activeName' @tab-click='handleTabsClick'>
        <el-tab-pane label='案例基本信息' name='essential'>
          <el-form :model='editForm' :rules='editFormUiCase' :label-position='labelPosition' ref='editForm'
                    label-width='80px' class='demo-editForm' size='small'>
            <el-form-item label='用例名称' prop='casename' label-width='width: 100%;'>
              <el-input v-model='editForm.casename' autocomplete='off'></el-input>
            </el-form-item>
            <el-form-item label='测试地址' prop='url' label-width='width: 100%;'>
              <el-input v-model='editForm.url' autocomplete='off'></el-input>
            </el-form-item>
            <el-form-item label='终端' prop='terminal' label-width='width: 100%;'>
              <el-select v-model='editForm.terminal' clearable placeholder='请选择终端'>
                <el-option
                  v-for='item in terminalTypeAll'
                  :key='item.value'
                  :label='item.label'
                  :value='item.label'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label='浏览器' prop='deviname' label-width='width: 100%;'>
              <el-select v-model='editForm.deviname' clearable placeholder='请选择操作浏览器'>
                <el-option
                  v-for='item in deviceNameAll'
                  :key='item.value'
                  :label='item.label'
                  :value='item.label'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label='浏览器版本号' prop='vsion' label-width='width: 100%;'>
              <el-input v-model='editForm.vsion' autocomplete='off'></el-input>
            </el-form-item>
            <el-form-item label='用例描述' prop='description' label-width='width: 100%;'>
              <el-input v-model='editForm.description' autocomplete='off'></el-input>
            </el-form-item>
            <el-form-item label='状态' prop='statu' label-width='width: 100%;'>
              <el-radio-group v-model='editForm.statu'>
                <el-radio :label=0>禁用</el-radio>
                <el-radio :label=1>正常</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item size='large'>
              <el-button type='primary' @click='submitForm("editForm")'>立即创建</el-button>
              <el-button @click='resetForm("editForm")'>重置</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label='案例基本步骤' name='second'>
          <el-form :inline='true'>
            <el-form-item>
              <el-button type='primary' @click='getElesList'>选择步骤</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data='UseCaseStepAll'
            style='width: 100%;margin-bottom: 20px;'
            :row-key='getRowKey'
            border
            :tree-props='{children: "children", hasChildren: "hasChildren"}'>
          <el-table-column
            prop='elementname'
            label='元素名称'
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop='operationtype'
            label='操作方式'
            show-overflow-tooltip>
            <template slot-scope='scope'>
              <p size='small' v-if='scope.row.operationtype === "sendKeys"' >输入</p>
              <p size='small' v-if='scope.row.operationtype === "click"'>点击</p>
              <p size='small' v-if='scope.row.operationtype === "clear"'>清除</p>
              <p size='small' v-if='scope.row.operationtype === "switch"' >切换</p>
              <p size='small' v-if='scope.row.operationtype === "onRandomClick"' >随机点击</p>
              <p size='small' v-if='scope.row.operationtype === "onFormClick"' >表单点击</p>
              <p size='small' v-if='scope.row.operationtype === "onMoveDowClick"' >移动到元素并点击</p>
              <p size='small' v-if='scope.row.operationtype === "openWindows"' >打开新窗口</p>
              <p size='small' v-if='scope.row.operationtype === "onAssertionText"' >检查元素值</p>
            </template>
          </el-table-column>
          <el-table-column
            prop='datatype'
            label='预期结果'
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop='elementdesc'
            label='实际结果'
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop='opentestallcond'
            label='该元素前面所有的测试条件'
            show-overflow-tooltip>
            <template slot-scope='scope'>
              <el-tag size='small' v-if='scope.row.opentestallcond === 1'>--</el-tag>
              <el-tag size='small' v-else-if='scope.row.opentestallcond === 0' type='success'>开启</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label='操作'
            width='400'>
            <template slot-scope='scope'>
              <el-button
                size='mini'
                :disabled='scope.$index === 0'
                @click='moveUp(scope.row ,scope.$index)'>上移
              </el-button>
              <el-button
                size='mini'
                @click='moveDown(scope.row ,scope.$index)'>下移
              </el-button>
              <el-button
                size='mini'
                type='danger'
                @click='deleteItem(scope.row.id,scope.$index)'>删除
              </el-button>
            </template>
          </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog
      :title='elePopUpTitle'
      :visible.sync='dialogElesVisible'
      width='80%'
      :before-close='handleElesAddClose'>
      <el-form :inline='true'>
        <el-form-item>
          <el-input
            v-model='searchForm.modulelocation'
            placeholder='元素名称'
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click='getElesList'>搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref='multipleTable'
        :data='tableAddElesData'
        tooltip-effect='dark'
        style='width: 100%'
        border
        stripe
        @selection-change='handleSelectionElesChange'>
        <el-table-column
          type='selection'
          width='55'>
        </el-table-column>
        <el-table-column
          prop='modulelocation'
          label='模版名称'
          width='120'>
        </el-table-column>
        <el-table-column
          prop='elementname'
          label='元素名称'
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop='locationtype'
          label='元素定位方式'
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop='locationvalue'
          label='元素定位值'
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop='operationtype'
          label='操作元素方式'
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop='datatype'
          label='输入值数据类型'
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop='elementdesc'
          label='描述'
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop='statu'
          label='状态'>
          <template slot-scope='scope'>
            <el-tag size='small' v-if='scope.row.statu === 1' type='success'>正常</el-tag>
            <el-tag size='small' v-else-if='scope.row.statu === 0' type='danger'>禁用</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change='handleElesSizeChange'
        @current-change='handleElesCurrentChange'
        layout='total, sizes, prev, pager, next, jumper'
        :page-sizes='[10, 20, 50, 100]'
        :current-page='current'
        :page-size='size'
        :total='total'
        style='text-align: right;width: 100%;margin: 20px'>
      </el-pagination>
      <span slot='footer' class='dialog-footer'>
                <el-button @click='handleElesAddClose'>取 消</el-button>
                <el-button type='primary' @click='saveUseCaseSteps'>确 定</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import Editor from './WEditorIndex'
export default {
  name: 'UseCase',
  components: {Editor},
  data () {
    return {
      activeNameBehaviorValue: '',
      dialogBehavior: false,
      selectDialogBehavior: {
        resource: ''
      },
      selectDialogBehaviorDriven: false,
      detail: '',
      formLabelWidth: '120px',
      dialogEleAssertion: false,
      viewDetails: false,
      tableAddElesIndex: '',
      elePopUpTitle: '',
      powerMessageTableAll: [
        {
          value: 'Android',
          label: 'Android'
        }],
      fullscreenLoading: false,
      uiCaseId: '',
      dialogElesVisible: false,
      show: false,
      labelPosition: 'top',
      activeName: 'essential',
      tableAddUseCaseData: [],
      UseCaseSteps: [],
      UseCaseStepAll: [],
      terminalTypeAll: [{
        value: 'PC',
        label: 'PC'
      }],
      deviceNameAll: [{
        value: 'Google',
        label: 'Google'
      }],
      searchForm: {},
      delBtlStatu: true,
      total: 0,
      size: 10,
      current: 1,
      dialogVisible: false,
      editForm: {
        useCaseBehavior: {
          behaviorDrivenDescription: ''
        }
      },
      tableData: [],
      elesDataAll: [],
      tableAddElesData: [],
      editFormUiCase: {
        casename: [
          {required: true, message: '请输入用例名称', trigger: 'blur'}
        ],
        url: [
          {required: true, message: '请输入测试名称', trigger: 'blur'}
        ],
        terminal: [
          {required: true, message: '请选择终端', trigger: 'blur'}
        ],
        deviname: [
          {required: true, message: '请输入操作浏览器', trigger: 'blur'}
        ],
        description: [
          {required: true, message: '请输入操作元素方式', trigger: 'blur'}
        ],
        statu: [
          {required: true, message: '请选择状态', trigger: 'blur'}
        ]
      },
      multipleSelection: [],
      // permDialogVisible: false,
      // defaultProps: {
      //     children: 'children',
      //     label: 'name'
      // },
      // permUseCaseData: []
      eleAssertion: {
        sysElesId: '',
        sysElesIdFather: '',
        sysElesUseCaseId: ''
      }
    }
  },
  created () {
    this.getUiCaseList()
    // this.$axios.get('/use/case/list').then(res => {
    //     this.permUseCaseData = res.data.data
    // })
  },
  methods: {
    // selectBehaviorOrStep () {
    //   this.activeNameBehaviorValue = this.selectDialogBehavior.resource
    //   this.activeName = 'essential'
    //   if (this.selectDialogBehavior.resource === 1) {
    //     this.dialogBehavior = true
    //     this.selectDialogBehaviorDriven = false
    //     this.selectDialogBehavior = {}
    //   } else {
    //     this.dialogVisible = true
    //     this.selectDialogBehaviorDriven = false
    //     this.selectDialogBehavior = {}
    //   }
    // },
    selectDialogBehaviorDrivenClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.detail = ''
          this.editForm = {}
          done()
        })
        .catch(_ => {
        })
    },
    editorChangeSave () {
      console.log('123344')
      this.editForm.useCaseBehavior.behaviorDrivenDescription = this.detail
      this.$axios.post('/use_case_behavior/' + (this.editForm.id ? 'update' : 'save'), this.editForm).then(res => {
        console.log('123')
        this.$message({
          showClose: true,
          message: '恭喜你，操作成功',
          type: 'success'
        })
      })
    },
    showdetails () {
      if (this.viewDetails === 'false') {
        this.viewDetails = true
      } else {
        this.viewDetails = true
      }
    },
    editorChange (val) {
      console.log(val)
    },
    handleEdit (index, row) {
      console.log(index, row)
    },
    handleDelete (index, row) {
      console.log(index, row)
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      console.log('勾选')
      console.log(val)
      this.multipleSelection = val
      this.delBtlStatu = val.length === 0
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.size = val
      this.getUiCaseList()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.current = val
      this.getUiCaseList()
    },
    resetForm (formName) {
      // this.$refs[formName].resetFields();
      // this.dialogVisible = false
      this.detail = ''
      this.editForm = {}
    },
    handleClose () {
      this.editForm = {}
      this.dialogVisible = false
      this.activeName = 'essential'
    },
    getUiCaseList () {
      this.$axios.get('/use/case/list', {
        params: {
          casename: this.searchForm.casename,
          current: this.current,
          size: this.size
        }
      }).then(res => {
        this.tableData = res.data.data.records
        this.size = res.data.data.size
        this.current = res.data.data.current
        this.total = res.data.data.total
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('/use/case/' + (this.editForm.id ? 'update' : 'save'), this.editForm)
            .then(res => {
              this.uiCaseId = res.data.data.id
              console.log(this.uiCaseId)
                this.$message({
                  showClose: true,
                  message: '恭喜你，操作成功',
                  type: 'success',
                  onClose: () => {
                    this.getUiCaseList()
                    console.log('我进回调函数了')
                      this.$axios.get('/use/case/info/' + this.uiCaseId).then(res => {
                        this.editForm = res.data.data
                        this.dialogVisible = true
                      })
                  }
                })
              this.dialogVisible = false
              this.resetForm(formName)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editHandle (id) {
      this.uiCaseId = id
      this.activeName = 'essential'
      this.$axios.get('/use_case_behavior/' + id).then(res => {
        console.log('123')
        this.editForm = res.data.data
        if (res.data.data.useCaseBehavior == null) {
          this.$axios.get('/use/case/info/' + id).then(res => {
            this.editForm = res.data.data
            this.elesDataAll = res.data.data1
          })
          this.dialogVisible = true
          this.$axios.get('/use/case/getAllElesCase/' + id).then(res => {
            this.UseCaseStepAll = res.data.data
          })
        } else {
          this.dialogBehavior = true
          this.detail = this.editForm.useCaseBehavior.behaviorDrivenDescription
        }
      })
    },
    delHandle (id) {
      var ids = []
      if (id) {
        ids.push(id)
      } else {
        this.multipleSelection.forEach(row => {
          ids.push(row.id)
        })
      }
      console.log(ids)
      this.$axios.post('/use/case/delete', ids).then(res => {
        this.$message({
          showClose: true,
          message: '恭喜你，操作成功',
          type: 'success',
          onClose: () => {
            this.getUiCaseList()
          }
        })
      })
    },
    handleTabsClick () {
      console.log('11111')
      console.log(this.dialogBehavior)
      console.log(this.activeNameBehaviorValue)
      if (this.editForm.id == null && this.activeName !== 'essential' && this.activeNameBehaviorValue !== 1) {
        this.$message.error('请先保存用例基本信息！！！')
        this.activeName = 'essential'
      }
    },
    handleElesAddClose (done) {
      this.$confirm('确认不保存步骤？')
        .then(_ => {
          this.UseCaseSteps = []
          done()
        })
        .catch(_ => {
          this.UseCaseSteps = []
          this.dialogElesVisible = false
        })
    },
    getElesList () {
      this.dialogElesVisible = true
      this.elePopUpTitle = '选择步骤'
      this.$axios.get('/ui/eles/list', {
        params: {
          modulelocation: this.searchForm.modulelocation,
          current: this.current,
          size: this.size
        }
      }).then(res => {
        this.tableAddElesData = res.data.data.records
        this.size = res.data.data.size
        this.current = res.data.data.current
        this.total = res.data.data.total
      })
    },
    handleSelectionElesChange (val) {
      console.log('勾选1111')
      console.log(val)
      this.UseCaseSteps = val
      this.delBtlStatu = val.length === 0
    },
    saveUseCaseSteps () {
      this.$confirm('确认保存步骤？')
        .then(_ => {
          console.log(this.tableAddElesIndex)
          if (this.tableAddElesIndex != null && this.tableAddElesIndex !== '') {
            if (this.UseCaseSteps.length !== 1) {
              this.$message({
                showClose: true,
                message: '每次至多至少需要添加一个检查点',
                type: 'success'
              })
            } else {
              this.eleAssertion.sysElesIdFather = this.tableAddElesIndex
              this.UseCaseStepAll.forEach(row => {
                if (this.tableAddElesIndex === row.id) {
                  this.UseCaseSteps.forEach(step => {
                    this.eleAssertion.sysElesId = step.id
                    // row.children.push(step)
                    // console.log(row)
                    this.UseCaseSteps = []
                    this.dialogElesVisible = false
                    this.dialogEleAssertion = true
                  })
                }
              })
            }
          } else {
            this.tableAddUseCaseData = this.UseCaseSteps
            this.saveUseCaseStepall(this.tableAddUseCaseData)
            this.UseCaseSteps = []
            this.dialogElesVisible = false
          }
        })
    },
    moveUp (item, index) {
      this.UseCaseStepAll.splice(index - 1, 0, item)
      this.UseCaseStepAll.splice(index + 1, 1)
      console.log('开始')
      this.saveElesCaseOrder(this.UseCaseStepAll)
      console.log(this.UseCaseStepAll)
    },
    // xia移
    moveDown (item, index) {
      this.UseCaseStepAll.splice(index + 2, 0, item)
      this.UseCaseStepAll.splice(index, 1)
      this.saveElesCaseOrder(this.UseCaseStepAll)
      console.log(this.UseCaseStepAll)
    },
    // 删除
    deleteItem (itemId, index) {
      this.UseCaseStepAll.splice(index, 1)
      this.deleteElesCaseSteps(itemId)
      console.log(this.UseCaseStepAll)
    },
    // 保存用例步骤
    saveUseCaseStepall (tableAddUseCaseData) {
      let ids = {}
      let sysElesUseCaseList = []
      tableAddUseCaseData.forEach(row => {
        ids = {
          'useCaseId': this.uiCaseId,
          'elesId': row.id
        }
        sysElesUseCaseList.push(ids)
        ids = []
      })
      console.log(sysElesUseCaseList)
      this.$axios.post('/use/case/saveElesCase/', sysElesUseCaseList).then(res => {
        console.log('9999')
        this.tableAddUseCaseData = []
        this.UseCaseSteps = []
        this.dialogElesVisible = false
        this.UseCaseStepAll = res.data.data
        this.$message({
          showClose: true,
          message: '恭喜你，操作成功',
          type: 'success'
        })
      })
    },
    saveElesCaseOrder (tableAddUseCaseData) {
      let ids = {}
      let sysElesUseCaseList = []
      tableAddUseCaseData.forEach(row => {
        ids = {
          'useCaseId': this.uiCaseId,
          'elesId': row.id
        }
        sysElesUseCaseList.push(ids)
        ids = []
      })
      console.log(sysElesUseCaseList)
      this.$axios.post('/use/case/saveElesCaseOrder/', sysElesUseCaseList).then(res => {
        console.log('9999')
        console.log(this.tableAddUseCaseData)
        // this.uiCaseId= ''
        this.tableAddUseCaseData = []
        this.UseCaseSteps = []
        this.dialogElesVisible = false
        this.UseCaseStepAll = res.data.data
        this.$message({
          showClose: true,
          message: '恭喜你，操作成功',
          type: 'success'
        })
      })
    },
    deleteElesCaseSteps (itemId) {
      let ids = {}
      let sysElesUseCaseList = []
      ids = {
        'useCaseId': this.uiCaseId,
        'elesId': itemId
      }
      sysElesUseCaseList.push(ids)
      ids = []
      console.log(sysElesUseCaseList)
      this.$axios.post('/use/case/deleteElesCaseSteps/', sysElesUseCaseList).then(res => {
        this.$message({
          showClose: true,
          message: '恭喜你，操作成功',
          type: 'success'
        })
      })
    },
    runAllCaseOne (id) {
      this.fullscreenLoading = true
      this.$axios.get('/sys/tg/runAllCase/' + id, {timeout: 600000}).then(res => {
        this.fullscreenLoading = false
        this.$message({
          showClose: true,
          message: '恭喜你，用例运行成功',
          type: 'success'
        })
      })
    },
    runAllCase () {
      this.fullscreenLoading = true
      this.$axios.get('/sys/tg/runAllCase/', {timeout: 600000}).then(res => {
        this.fullscreenLoading = false
        this.$message({
          showClose: true,
          message: '恭喜你，用例运行成功',
          type: 'success'
        })
      })
    },
    runAllCaselLocal (id) {
      this.fullscreenLoading = true
      this.$axios.get('/sys/tg/runAllCaseLocal/' + id, {timeout: 600000}).then(res => {
        this.fullscreenLoading = false
        this.$message({
                showClose: true,
                message: res.data1.data,
                type: 'success'
              })
      })
    },
    handleElesSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.size = val
      this.getElesList()
    },
    handleElesCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.current = val
      this.getElesList()
    },
    automaticCaseGeneration () {
      var parmams = {
        'autoCaseGenList': this.UseCaseStepAll,
        'uiCaseId': this.uiCaseId
      }
      this.$axios.post('/use/case/automaticCaseGeneration/', parmams, {timeout: 600000}).then(res => {
        this.$message({
          showClose: true,
          message: res.data.data,
          type: 'success',
          onClose: () => {
            // this.getUiCaseList(),
            this.$axios.get('/use/case/info/' + this.uiCaseId).then(res => {
              this.editForm = res.data.data
              this.dialogVisible = true
              this.activeName = 'caseCollection'
              this.elesDataAll = res.data.data1
            })
          }
        })
      })
    },
    selectEleAssertion (index, sysElesUseCaseId) {
      console.log(index, sysElesUseCaseId)
      this.dialogElesVisible = true
      this.elePopUpTitle = '选择检查元素'
      this.eleAssertion.sysElesUseCaseId = sysElesUseCaseId
      this.tableAddElesIndex = index
      this.$axios.get('/ui/eles/list', {
        params: {
          modulelocation: this.searchForm.modulelocation,
          current: this.current,
          size: this.size
        }
      }).then(res => {
        this.tableAddElesData = res.data.data.records
        this.size = res.data.data.size
        this.current = res.data.data.current
        this.total = res.data.data.total
      })
    },
    saveEleAssertion () {
      this.$axios.post('/pm/eles/eleAssertionSave/', this.eleAssertion).then(res => {
        console.log(this.uiCaseId)
        this.eleAssertion = {}
        this.dialogEleAssertion = false
        this.editHandle(this.uiCaseId)
        this.$message({
          showClose: true,
          message: '恭喜你，操作成功',
          type: 'success'
        })
      })
    },
    getRowKey (row) {
      /** 检查row.id是否有重复的缓存对象 */
      if (!this.checkRepeatObj) {
        this.checkRepeatObj = {}
      }
      if (row) {
        if (row.id) {
          if (this.checkRepeatObj[row.id]) {
            if (!row._secondId) {
              row._secondId = Math.random() + ''
            }
            /** 方便根据key重用元素 */
            return row._secondId
          } else {
            this.checkRepeatObj[row.id] = 1
            return row.id
          }
        }
        console.log('row.id为空')
        if (!row._secondId) {
          row._secondId = Math.random() + ''
        }
        return row._secondId
      } else {
        console.log('row为空')
        return Math.random() + ''
      }
    }
  }
}
</script>
<style scoped>
.el-pagination {
  float: right;
  margin-top: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Case.vue